<template>
  <admin-card title="Редактирование теста" v-if="test">
    <form @submit.prevent="update" @keydown="form.onKeydown($event)">
      <!-- Test Title -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('test_title') }}</label>
        <div class="col-md-7">
          <input v-model="form.title" type="text" name="title" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('title') }">
          <has-error :form="form" field="title"></has-error>
        </div>
      </div>

      <!-- Test description -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('test_description') }}</label>
        <div class="col-md-7">
          <input v-model="form.description" type="text" name="description" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('description') }">
          <has-error :form="form" field="description"></has-error>
        </div>
      </div>

      <!-- Allowable Error Count -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('test_allowable_mistakes_count') }}</label>
        <div class="col-md-7">
          <input v-model="form.allowable_mistakes_count" type="number" min="0" max="100" name="allowable_mistakes_count" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('allowable_mistakes_count') }">
          <has-error :form="form" field="allowable_mistakes_count"></has-error>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="form-group row">
        <div class="col-md-9 ml-md-auto">
          <v-button class="btn btn-default" type="success" :loading="form.busy">{{ $t('update') }}</v-button>
        </div>
      </div>
    </form>

    <h2>{{ $t('test_questions') }}</h2>

    <table class="table table-striped table-bordered admin-table">
      <thead>
      <tr>
        <th colspan="4" class="admin-table__controls">
          <router-link :to="{ name: 'admin.question.add', params: { testId : test.id }}"
                       class="btn btn-primary"
                       active-class="active">
            {{ $t('add') }}
          </router-link>
        </th>
      </tr>
      <tr>
        <th>{{ $t('id') }}</th>
        <th>{{ $t('title') }}</th>
        <th>{{ $t('controls') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="question in questions">
        <th>{{ question.id }}</th>
        <th>{{ question.title }}</th>
        <th>
          <router-link :to="{ name: 'admin.question.edit', params: {testId : test.id, id: question.id} }"
                       class="btn btn-primary"
                       active-class="active">
            {{ $t('edit') }}
          </router-link>
          <button class="btn btn-warning" @click.prevent="removeQuestion(question)">{{ $t('delete') }}</button>
        </th>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th colspan="4" class="admin-table__controls">
          <router-link :to="{ name: 'admin.question.add', params: { testId : test.id }}"
                       class="btn btn-primary"
                       active-class="active">
            {{ $t('add') }}
          </router-link>
        </th>
      </tr>
      </tfoot>
    </table>
  </admin-card>

</template>

<script>
  import { mapGetters } from 'vuex'
  import { Form } from 'vform'
  import AdminPage from "../admin-page";

  export default {
    metaInfo () {
      return { title: this.$t('edit_test') }
    },
    extends: AdminPage,
    computed: mapGetters({
      users: 'users/users',
      test: 'tests/test',
      questions: 'questions/questions'
    }),
    data: () => ({
      form: new Form({
        id: 0,
        title: '',
        description: '',
        allowable_mistakes_count: 0,
      })
    }),
    methods: {
      async update () {
        const { data } = await this.form.patch('/api/admin/tests/' + this.test.id);

        this.$store.dispatch('tests/updateTest', { test: data });
        this.$alertify.success(this.$t('admin.global.labels.alert-success'));
      },

      async removeQuestion (question) {
        if (confirm('Вы уверены, что хотите удалить вопрос теста "' + question.title + '"?')) {
          const {data} = await this.form.delete('/api/admin/questions/' + question.id);

          this.questions.splice(this.questions.findIndex(l => parseInt(l.id) === parseInt(question.id)), 1);
        }
      },
    },
    mounted () {
      this.$store.dispatch('tests/fetchFullTest', this.$route.params.id)
        .then(e => {
          // Fill the form with test data.
          this.form.keys().forEach(key => {
            this.form[key] = this.test[key]
          });
        });

      this.$store.dispatch('questions/fetchFullTestQuestions', this.$route.params.id);
    },
    beforeMount () {
      this.$store.dispatch('users/fetchAll');
    }
  }
</script>
